module.exports = __webpack_public_path__ + "static/media/logo-pgm-white-mode.4f6f196a.svg";